import { EmojiPlayer } from "./EmojiPlayer.js";
import { Timeline, TimelineAddOptions } from "./Timeline.js";

export interface EmojiDelegateOptions {
    container: HTMLElement;
    timeline: Timeline;
}

export interface EmojiDelegateSource {
    dragging: boolean;
}

export interface EmojiDelegateInfo extends TimelineAddOptions {
    source?: EmojiDelegateSource;
    event: e5.ActorEvent;
    pivotX: number;
    pivotY: number;
}

export class EmojiDelegate {
    private _element: HTMLElement;
    private _timeline: Timeline;
    private _emojiPlayer: EmojiPlayer;
    private _actor: e5.Click;
    private _info: EmojiDelegateInfo = null;

    constructor(options: EmojiDelegateOptions) {
        options = e5.object.merge({

        }, options);

        this._timeline = options.timeline;

        this._element = document.createElement("div");
        this._element.className = "emoji-delegate emoji-delegate--hidden";
        this._element.innerHTML = `
            <div class="emoji-delegate__icon"></div>
        `;

        this._emojiPlayer = new EmojiPlayer({
            container: this._element.querySelector(".emoji-delegate__icon"),
            // renderer: "canvas"
        });

        let updatePosition = () => {
            let local = e5.Transform.toLocal(this._element.parentElement, this._actor.pointer.x, this._actor.pointer.y);

            let tx = local.x - this._info.pivotX;
            let ty = local.y - this._info.pivotY;
            this._element.style.transform = `translate(${tx.toPrecision(8)}px, ${ty.toPrecision(8)}px)`;
        };

        let pt = document.createElement("div");
        pt.style.backgroundColor = "#F0F";
        pt.style.position = "absolute";
        pt.style.width = "10px";
        pt.style.height = "10px";
        pt.style.zIndex = "100";
        pt.style.top = "0";
        pt.style.left = "0";
        // options.container.appendChild(pt);

        let getCenter = () => {
            const x = this._actor.pointer.x + (this._element.offsetWidth * 0.5 - this._info.pivotX);
            const y = this._actor.pointer.y + (this._element.offsetHeight * 0.5 - this._info.pivotY);
            pt.style.transform = `translate(${x}px, ${y}px) translate(-50%, -50%)`;
            return {
                x: x,
                y: y
            };
        };

        this._actor = new e5.Click();
        // this._actor.useCapture = true;

        this._actor.onStart.add(
            () => {
                if (!this._info) {
                    return;
                }

                if (this._info.source) {
                    this._info.source.dragging = true;
                }

                updatePosition();
                this._element.classList.remove("emoji-delegate--hidden");
                this._emojiPlayer.load(this._info.emoji.lottieData);
                this._timeline.dragStart(this._info, getCenter());
            });

        this._actor.onMove.add(
            () => {
                if (!this._info) {
                    return;
                }
                updatePosition();
                this._timeline.dragMove(this._info, getCenter());
            });

        this._actor.onClear.add(
            () => {
                if (!this._info) {
                    return;
                }

                const added = this._timeline.dragEnd(this._info, getCenter());

                if (this._info.source) {
                    this._info.source.dragging = false;
                }

                this._info = null;

                this._element.classList.add("emoji-delegate--hidden");
            });

        options.container.appendChild(this._element);

        e5.Player.onTick.add(() => {
            if (!this._info) {
                return;
            }
            this._actor.onMove.dispatch(null, null);
        });
    }

    public get isBusy(): boolean {
        return Boolean(this._info);
    }

    public start(info: EmojiDelegateInfo): void {
        if (this._info) {
            return;
        }

        info = e5.object.merge({
            speed: 1,
            playing: false,

        }, info);

        this._info = info;
        this._actor.start(info.event);
    }
}